module.exports = __webpack_public_path__ + "img/photoAlbum1.76ed86f8.jpg";